module.exports = __webpack_public_path__ + "bath.svg?9561518b048234e17b0b66177635293e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bath.svg
// module id = 3
// module chunks = 0